import * as smartpromise from '@push.rocks/smartpromise';

export { smartpromise };
